// Matches AWS Cognito password policy special characters.
const COGNITO_SPECIAL_CHAR_REGEX = /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]/;

export function hasCognitoSpecialChar(password) {
  if (!password || typeof password !== 'string') return false;
  if (COGNITO_SPECIAL_CHAR_REGEX.test(password)) return true;

  for (let i = 1; i < password.length - 1; i += 1) {
    if (password[i] === ' ') return true;
  }

  return false;
}

export function getPasswordRequirementStatus(password = '') {
  return {
    minLength: password.length >= 8,
    lowercase: /[a-z]/.test(password),
    uppercase: /[A-Z]/.test(password),
    number: /[0-9]/.test(password),
    specialChar: hasCognitoSpecialChar(password),
  };
}

export function isValidCognitoPassword(password) {
  if (!password) return false;
  const status = getPasswordRequirementStatus(password);
  return Object.values(status).every(Boolean);
}
